import $ from "jquery";
import "what-input";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import "./lib/foundation-explicit-pieces";
import "slick-carousel/slick/slick";
import "lightgallery/dist/js/lightgallery-all.js";
import "hc-sticky/dist/hc-sticky";
import "lazysizes";
import "waypoints/lib/noframework.waypoints";
import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js";
import "jquery-match-height";
import "imagesloaded";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import esLocale from "@fullcalendar/core/locales/es";

// import Moment from 'moment/dist/moment';
// import { extendMoment } from 'moment-range';
// import 'moment/min/locales';

//const moment = extendMoment(Moment);

$(document).foundation();

$(document).ready(function () {
  var direction =
    $("html").css("direction").toLowerCase() === "rtl" ? "right" : "left";
  var isRTL = $("html").css("direction").toLowerCase() === "rtl";

  // $("#return-to-top, .scroll-top").click(function () {
  //     $("body,html").animate({scrollTop: 0}, 500)
  // });

  $(".search-trigger").on("click", function (ev) {
    ev.preventDefault();
    $(".search-overlay").show();
  });

  $(".search-overlay-close-button a").on("click", function (ev) {
    ev.preventDefault();
    $(".search-overlay").hide();
  });

  if ($(".dropdown-wrapper").length) {
    $(".dropdown-wrapper button").on("click", function () {
      $(this).next().toggleClass("expand");
    });
  }

  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      // escape key maps to keycode `27`
      $(".dropdown-wrapper button").next().removeClass("expand");
    }
  });

  var leaderTimeout;
  var stickyHeaderAd = $(".ad-block-header"),
    stickyHeaderAdAttribute = "data-duration";

  var stickyHeader = new hcSticky("#sticky-header", {
    stickTo: "body",
    onStart: function () {
      $(".canvas-panel").css("top", $(".main-header-inner").outerHeight());
      //var stickyTopDuration = $("#leaderboard").data("duration") * 1000;

      //on scroll down
      // leaderTimeout = setTimeout(function () {
      //   $("#leaderboard").slideUp("fast"); //hide leaderboard after 3 seconds
      // }, stickyTopDuration);

      $(".ad-block-header").each(function () {
        var $this = $(this);
        if (
          $this.is(":visible") &&
          $this.attr(stickyHeaderAdAttribute) !== "undefined" &&
          $this.attr(stickyHeaderAdAttribute) !== ""
        ) {
          stickyHeaderAdHide($this);
        }
      });

      $("#navpanel").addClass("has-sticky");
    },
    onStop: function () {
      $(".canvas-panel").css("top", $("#main-header").outerHeight());

      // on sticky stop
      // clearTimeout(leaderTimeout);
      // $("#leaderboard").slideDown("fast");
      if ($(".ad-hidden").length) {
        clearTimeout(leaderTimeout);
        stickyHeaderAdShow();
      }

      $("#navpanel").removeClass("has-sticky");
    },
  });

  function stickyHeaderAdHide($this) {
    if (
      $this.is(":visible") &&
      $this.attr(stickyHeaderAdAttribute) !== "undefined" &&
      $this.attr(stickyHeaderAdAttribute) !== ""
    ) {
      var stickyHeaderAdDuration = $this.data("duration") * 1000;
      // console.log($this, stickyHeaderAdDuration, "stickyHeaderAdDuration");
      leaderTimeout = setTimeout(function () {
        $this.slideUp("fast").addClass("ad-hidden"); //hide leaderboard after 3 seconds
      }, stickyHeaderAdDuration);
    }
  }

  function stickyHeaderAdShow() {
    $(".ad-hidden").slideDown("fast").removeClass("ad-hidden");
  }

  var stickyHeaderAd = new hcSticky("#sticky-ad-header", {
    // stickTo: '#main-wrap',
    // onStart: function () {
    //     $('.canvas-panel').css('top', $('.disappearing-ad_js').outerHeight());
    // },
    // onStop: function () {
    //     $('.canvas-panel').css('top', $('main').outerHeight());
    // }
  });

  if ($("#sticky-ad-header").length > 0) {
    var stickyAdHeader = document.getElementsByClassName("disappearing-ad_js");

    for (var i = 0; i < stickyAdHeader.length; i++) {
      new hcSticky(stickyAdHeader[i], {
        stickTo: stickyAdHeader[i].parentNode,
        top: 0,
        // bottomEnd: 30
        // responsive: {
        //     800: {
        //         disable: true
        //     }
        // }
      });
    }
  }

  // NEW HEADER SEPT-8-2023
  if ($(".toggle-nav-panel").length) {
    $(".toggle-nav-panel").on("click", function () {
      // Toggle Navpanel
      $(".navpanel").toggleClass("active");
      // Toggle icon
      $(".toggle-nav-panel i").toggleClass("icon-menu icon-close");
    });
  }

  if ($(".navpanel").length) {
    $(".nav__title").on("click", function () {
      // Toggle Navpanel
      $(this).toggleClass("active");
      $(this).next().toggleClass("active");
    });
  }

  // Initialize Slidebars
  // var controller = new slidebars();
  // controller.init();

  // $(document).on('click', '.toggle-nav-panel, .more-menu', function (event) {
  //     // Stop default action and bubbling
  //     event.stopPropagation();
  //     event.preventDefault();

  //     $('.toggle-nav-panel i').toggleClass('icon-menu icon-close');
  //     $('.more-menu').toggleClass('opened-panel');
  //     //console.log("panel");
  //     // Toggle the Slidebar with id 'id-4'
  //     controller.toggle('nav-panel');
  // });

  // Add close class to canvas container when Slidebar is opening
  //   var maxHeight;
  //   $(controller.events).on("opening", function (event) {
  //     $('[canvas="container"]').addClass("sb-opening");
  //     /*if ($('.stuck-header').length > 0) {
  //          $('.canvas-panel, .filter-panel-holder').css({"top": stickyHeader.height()});
  //          } else {
  //          $('.canvas-panel, .filter-panel-holder').css({"top": AreaToStick.height()});
  //          }*/
  //   });

  //   // Add close class to canvas container when Slidebar is opening
  //   $(controller.events).on("opened", function (event) {
  //     $('[canvas="container"]').addClass("sb-opened");
  //   });

  //   // Remove close class from canvas container when Slidebar is closing
  //   $(controller.events).on("closing", function (event) {
  //     $('[canvas="container"]').removeClass("sb-opening");
  //   });

  //   // Remove close class from canvas container when Slidebar is closing
  //   $(controller.events).on("closed", function (event) {
  //     $('[canvas="container"]').removeClass("sb-opened");
  //   });

  // Close any
  $(document).on(
    "click",
    ".close-panel span, .more-menu.opened-panel",
    function (event) {
      //.sb-opening
      if (controller.getActiveSlidebar()) {
        event.preventDefault();
        event.stopPropagation();
        controller.close();
      }
      // $('.toggle-nav-panel').click()
    }
  );

  //share social media button
  $(".share-trigger_js").on("click", function () {
    $(".socials-share").slideToggle();
    $(this).toggleClass("clicked");
  });

  // // done modal - hash

  // if(window.location.hash) {
  //     var hash = window.location.hash;
  //    $(hash).foundation('open');
  // }

  // if ($(".sticky-area").length > 0) {
  //   var stickySectionTitles = document.getElementsByClassName("sticky-area");

  //   for (var i = 0; i < stickySectionTitles.length; i++) {
  //     console.log(stickySectionTitles[i].parentNode, "parent");
  //     new hcSticky(stickySectionTitles[i], {
  //       stickTo: stickySectionTitles[i].parentNode,
  //       top: 80,
  //       // bottomEnd: 30,
  //       followScroll: false,
  //       responsive: {
  //         800: {
  //           disable: true,
  //         },
  //       },
  //     });
  //   }
  // }

  if ($(".sticky-sidebar").length > 0) {
    var stickySectionTitles = document.getElementsByClassName("sticky-sidebar");

    for (var i = 0; i < stickySectionTitles.length; i++) {
      new hcSticky(stickySectionTitles[i], {
        stickTo: stickySectionTitles[i].parentNode.parentNode,
        top: 80,
        bottomEnd: 30,
        responsive: {
          800: {
            disable: true,
          },
        },
      });
    }
  }

  // function = if item is showing
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // STICKY AD
  // if ($(".sticky-area").length) {
  //   if ($(window).width() > 1024) {
  //     var stickyMpuEl = document.getElementsByClassName("sticky-area");
  //     var stickyMpu;
  //     for (var i = 0; i < stickyMpuEl.length; i++) {
  //       stickyMpu = new hcSticky(stickyMpuEl[i], {
  //         stickTo: stickyMpuEl[i].parentNode,
  //         top: 80,
  //       });
  //     }
  //     $(window).on("scroll", function () {
  //       var st = $(this).scrollTop();

  //       var sideBarEnd = 0;
  //       if ($(".sidebar-wrap").length) {
  //         sideBarEnd =
  //           $(".sidebar-wrap").offset().top + $(".sidebar-wrap").height();
  //       }

  //       if (st > sideBarEnd) {
  //         stickyMpu.attach();
  //       } else {
  //         stickyMpu.destroy();
  //         clearTimeout(timeout);
  //         $(".sticky-side-mpu #mpu").show();
  //       }
  //     });
  //   }
  // }
  if ($(".sticky-side-mpu").length > 0) {
    if ($(window).width() > 1024) {
      var stickyElement = $(".sticky-side-mpu")[0],
        timeout;

      var stickySideMpu = new hcSticky(stickyElement, {
        stickTo: $(".sticky-side-mpu")[0].parentNode.parentNode,
        top: 40,
        onStart: function () {
          var stickyDuration =
            $(".sticky-side-mpu #mpu").data("duration") * 1000;
          //on scroll down
          timeout = setTimeout(function () {
            $(".sticky-side-mpu #mpu").hide(); //hide mpu after 3 seconds
          }, stickyDuration);
        },
        onStop: function () {
          // on sticky stop
          clearTimeout(timeout);
          $(".sticky-side-mpu #mpu").show();
        },
      });
    }
  }

  if ($(".close_js").length > 0) {
    $(".close_js").on("click", function () {
      $(this).parent("div").fadeOut();
    });
  }

  var $verticalTinySlider = $(".vertical-tiny-slider_js");
  $verticalTinySlider.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    prevArrow: $(".v-prev"),
    nextArrow: $(".v-next"),
    // rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          arrows: false,
          verticalSwiping: false,
        },
      },
      // {
      //     breakpoint: 641,
      //     settings: {
      //         slidesToShow: 6,
      //         slidesToScroll: 6
      //     }
      // }
    ],
  });

  var $verticalSlider = $(".vertical-slider_js");
  $verticalSlider.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    prevArrow: $(".v-prev"),
    nextArrow: $(".v-next"),
    // rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
          arrows: false,
          verticalSwiping: false,
        },
      },
      // {
      //     breakpoint: 641,
      //     settings: {
      //         slidesToShow: 6,
      //         slidesToScroll: 6
      //     }
      // }
    ],
  });

  var $mostReadCarousel = $(".most-read-carousel_js");
  $mostReadCarousel.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    // prevArrow: $('.v-prev'),
    // nextArrow: $('.v-next'),
    rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          centerMode: true,
          adaptiveHeight: false,
          arrows: false,
          centerPadding: "150px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

  var bp = [
    {
      breakpoint: 641,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        centerMode: true,
        arrows: false,
        centerPadding: "150px",
      },
    },
    { breakpoint: 768, settings: { slidesToShow: 3 } },
  ];

  if ($(".front").length > 0) {
    $mostReadCarousel.slick("slickSetOption", "slidesToShow", 3);
    $mostReadCarousel.slick("slickSetOption", "responsive", bp, true);
    $mostReadCarousel.slick("refresh");
  }

  var $seriesCarousel = $(".series-carousel_js");
  $seriesCarousel.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    // prevArrow: $('.v-prev'),
    // nextArrow: $('.v-next'),
    rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          centerMode: true,
          adaptiveHeight: false,
          arrows: false,
          centerPadding: "70px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

  var $avatarsList = $(".avatars-list_js");
  $avatarsList.slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 415,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 969,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
    ],
  });

  var $heroesCarousel = $(".heroes-carousel_js");
  $heroesCarousel.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    // prevArrow: $('.v-prev'),
    // nextArrow: $('.v-next'),
    rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          centerMode: true,
          adaptiveHeight: false,
          arrows: false,
          centerPadding: "80px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  });

  var $horoscopeCarousel = $(".horoscope-carousel_js");
  $horoscopeCarousel.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    // prevArrow: $('.v-prev'),
    // nextArrow: $('.v-next'),
    rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 3,
          centerMode: true,
          adaptiveHeight: false,
          arrows: false,
          centerPadding: "70px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 981,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
    ],
  });

  var $productsCarousel = $(".products-carousel_js");
  $productsCarousel.slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    // prevArrow: $('.v-prev'),
    // nextArrow: $('.v-next'),
    rtl: true,
    accessibility: false,
    mobileFirst: false,
    adaptiveHeight: true,
    responsive: [
      // {
      //     breakpoint: 376,
      //     settings: {
      //         slidesToShow: 2,
      //         slidesToScroll: 2
      //     }
      // },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          centerMode: true,
          adaptiveHeight: false,
          arrows: false,
          centerPadding: "100px",
        },
      },
      {
        breakpoint: 641,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 971,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
    ],
  });

  var productsCarousel_bp = [
    {
      breakpoint: 641,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        centerMode: true,
        arrows: false,
        centerPadding: "150px",
      },
    },
    { breakpoint: 769, settings: { slidesToShow: 3 } },
  ];

  // ============================================== //
  // ============== RIYADH SEASON page  ============== //

  var $videoSlider = $(".video-slider_js");
  if ($videoSlider.length > 0) {
    $videoSlider.slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      rtl: true,
      centerMode: false,
      asNavFor: ".video-nav_js",
    });
    $(".slick-current.slick-active", $videoSlider).addClass("play");
    $(".play video", $videoSlider).get(0).play();

    $videoSlider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        var CurrentSlideDom = $(slick.$slides.get(currentSlide));

        $("video", CurrentSlideDom).get(0).pause();
        $("video", CurrentSlideDom).get(0).currentTime = 0;
        //console.log($("video", CurrentSlideDom).get(0), "BEFORE-CHANGE");
      }
    );

    $videoSlider.on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        var CurrentSlideDom = $(slick.$slides.get(currentSlide));
        //console.log($("video", CurrentSlideDom).get(0), "AFTERCHANGE");
        $("video", CurrentSlideDom).get(0).play();
      }
    );

    //for circle nav on video slider
    $(".video-nav_js").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".video-slider_js",
      dots: false,
      focusOnSelect: true,
      rtl: true,
    });
  }

  // GO-TO SCRIPT -- start
  var $root = $("html, body");

  // $(window).on('scroll', function() {
  //     console.log($('#sticky-header.sticky').height(),'header');
  // });

  //RIYADH SEASON SCROLL TO SECTION
  $('.sm-menu-slide_js a[href^="#"]').on("click", function () {
    var href = $.attr(this, "href");
    $root.animate(
      {
        scrollTop: $(href).offset().top - $("#sticky-header.sticky").height(),
      },
      500,
      function () {
        window.location.hash = href;
      }
    );

    return false;
  });

  // GO-TO SCRIPT -- end

  var $guestCarousel = $(".guest-carousel_js"),
    settings = {
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      rtl: true,
      accessibility: false,
      mobileFirst: true,
      adaptiveHeight: false,
      centerMode: false,
    };

  $guestCarousel.slick(settings);

  function ifSmallScreen() {
    if ($window.width() < 640) {
      $guestCarousel.removeClass("slick-loading-area");
      if ($guestCarousel.hasClass("slick-initialized"))
        $guestCarousel.slick("unslick");
      return;
    }
    if (!$guestCarousel.hasClass("slick-initialized"))
      return $guestCarousel.slick(settings);
  }

  // magazine section - change to slider on mobile
  var $smallWindowCarousel = $(".s-carousel_js"),
    smallWindowCarouselSettings = {
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: "30px",
      dots: false,
      arrows: true,
      rtl: true,
    };

  function mobileSlider() {
    if ($window.width() < 640) {
      $smallWindowCarousel.slick(smallWindowCarouselSettings);
    } else {
      //$smallWindowCarousel.slick('unslick');
    }
  }

  var $smMenuSlide = $(".sm-menu-slide_js"),
    smMenuSlideSettings = {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      rtl: true,
    };

  //submenu -  change to slider on mobile
  function smMenuSlide() {
    if ($window.width() < 640) {
      $smMenuSlide.slick(smMenuSlideSettings);
    } else {
      // $smMenuSlide.slick('unslick');
    }
  }

  var $window = $(window);
  $window.on("resize", function () {
    ifSmallScreen();
    mobileSlider();
    smMenuSlide();
  });
  ifSmallScreen();
  mobileSlider();
  smMenuSlide();

  var $fullCarousel = $(".full-carousel_js");
  $fullCarousel.slick({
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerPadding: "550px",
    dots: false,
    arrows: true,
    rtl: true,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          centerPadding: "35px",
        },
      },
      {
        breakpoint: 769,
        settings: {
          centerPadding: "250px",
        },
      },
      {
        breakpoint: 1025,
        settings: {
          centerPadding: "100px",
        },
      },
    ],
  });

  // PHONE W AREA CODE
  if ($(".phone_js").length > 0) {
    var inputPhone = document.querySelector(".phone_js");
    $(".phone_js").each(function () {
      window.intlTelInput(this, {
        separateDialCode: true,
        preferredCountries: ["sa"],
      });
    });
  }

  //on click attend button will show the form
  $(".attend_js").on("click", function () {
    $(".guest-register_js").slideToggle();
    $(".guest-modal").animate(
      {
        scrollTop: $(this).offset().top,
      },
      500
    );

    $(this).hide();
  });

  //close guest register modal
  $(".cls-btn_js").on("click", function () {
    $(".guest-register_js").hide();
    $(".attend_js").show();
  });

  //on success of registration
  $(".submit_js").on("click", function () {
    $(".gst-modal_js").foundation("close");
    $(".guest-register_js").hide();
    $(".attend_js").show();

    $(".msg_js").foundation("open");
  });

  // ============== end RIYADH SEASON  ============== //
  // ============================================== //

  if ($(".article-products_js").length > 0) {
    $productsCarousel.slick("slickSetOption", "slidesToShow", 3);
    $productsCarousel.slick(
      "slickSetOption",
      "responsive",
      productsCarousel_bp,
      true
    );
    $productsCarousel.slick("refresh");
  }

  // article media-slider

  var mediaSlider = $(".media-slider");
  var mediaImgHeight;
  var sliderContentHeight;
  mediaSlider.slick({
    //lazyLoad: "progressive",
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    fade: true,
    adaptiveHeight: true,
    mobileFirst: true,
    rtl: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          swipe: false,
        },
      },
    ],
  });

  if ($(".media-slider-thumb_js").length > 0) {
    mediaSlider.slick("slickSetOption", "asNavFor", ".media-slider-thumb_js");
    mediaSlider.slick("refresh");

    var mediaSliderThumb = $(".media-slider-thumb_js");

    mediaSliderThumb.slick({
      slidesToShow: 6.5,
      slidesToScroll: 1,
      infinite: false,
      asNavFor: ".media-slider",
      dots: false,
      rtl: true,
      adaptiveHeight: false,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 641,
          settings: {
            slidesToShow: 3.5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4.5,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  function fixCtrlPosition() {
    // mediaImgHeight = $('.media-slider .slick-current img').height();
    // console.log(mediaImgHeight);
    // $('.media-slider .slick-prev, .media-slider .slick-next').css({'top': (mediaImgHeight - 50) / 2});

    sliderContentHeight =
      mediaSlider.find(".slick-current .slider-item-caption").outerHeight() ||
      0;
    // console.log(sliderContentHeight);
    mediaSlider
      .find(".slick-prev, .slick-next")
      .css({ "margin-top": -(sliderContentHeight + 50) / 2 });
  }

  mediaSlider.on("setPosition", function (slick) {
    fixCtrlPosition();
    if (mediaSlider.length > 0) {
      $(".slick-arrow").css({
        "margin-top": "0",
        top: $(".slider-item-img").height() / 2,
      });
    }
  });
  mediaSlider.on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      if (window.LimelightPlayer) {
        LimelightPlayer.doPause();
      }
      if ($(slick.$slides[currentSlide]).find(".yt_player_iframe").length > 0) {
        $(slick.$slides[currentSlide])
          .find(".yt_player_iframe")[0]
          .contentWindow.postMessage(
            '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
            "*"
          );
      }
    }
  );
  mediaSlider.on("afterChange", function (slick, currentSlide) {
    //mediaImgHeight = $(slick.$slides.get(slick.currentSlide)).find('.slider-item-img').height();
    //$('.media-slider .slick-prev, .media-slider .slick-next').css('top',(mediaImgHeight-54)/2);
    //call_google_analytics();
  });

  var $photographerCarousel = $(".photographer-slider_js");
  $photographerCarousel.slick({
    rows: 1,
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 11,
    slidesToScroll: 1,
    rtl: true,
    accessibility: false,

    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 360,
        settings: {
          centerMode: true,
          centerPadding: "25px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // if ($(".album-slider_js").length > 0) {
  //     var h;
  //     var l = function() {
  //             h = $(".album-slider_js .slick-current img").height(), $(".album-slider_js .slick-prev, .album-slider_js .slick-next").css({
  //                 top: (h + 25) / 2
  //             }), $(".album-slider_js.visa-guide .slick-prev, .album-slider_js.visa-guide .slick-next").css({
  //                 top: 0,
  //                 height: "63.5%"
  //             })
  //         }

  //     var g = $(".album-slider_js");
  //     g.slick({
  //         //lazyLoad: "ondemand",
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         arrows: !0,
  //         fade: !0,
  //         swipe: !1,
  //         rtl: !0,
  //         responsive: [{
  //             breakpoint: 992,
  //             settings: {
  //                 swipe: !0
  //             }
  //         }]
  //     }), g.on("setPosition", function(t) {
  //         l()
  //     })
  // }

  if ($(".album-slider_js").length > 0) {
    var h,
      m,
      p,
      g = $(".album-slider_js");
    g.each(function (t) {
      var e = $(this);
      e.slick({
        //lazyLoad: "ondemand",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        rtl: true,
        adaptiveHeight: false,
      }),
        e.on("setPosition", function (t) {
          $(".album-slider_js .slick-current img").height(),
            $(".album-slider_js .slick-prev, .album-slider_js .slick-next").css(
              {
                top: (h + 25) / 2,
              }
            ),
            $(
              ".album-slider_js.visa-guide .slick-prev, .album-slider_js.visa-guide .slick-next"
            ).css({
              top: 0,
              height: $(".album-slider_js .slick-current img").height(),
            });
          // m = e.height(), p = e.find(".slick-current .slider-item-caption").outerHeight() || 0, e.find(".slick-prev, .slick-next").css({
          //     height: m - (p + 20) + "px"
          //})
        });
    });
  }

  //article - lightgallery
  if ($(".lightgallery_js").length > 0) {
    var $lightgalleryElement = $(".lightgallery_js");
    $lightgalleryElement.lightGallery({
      selector: ".lightgallery-trigger_js", //$(this).find('.lightgallery-trigger_js'),
      thumbnail: false,
      autoplayControls: false,
      actualSize: false,
      fullScreen: false,
      zoom: false,
      currentPagerPosition: "middle",
      animateThumb: true,
      share: false,
      exThumbImage: "data-exthumbimage",
      //  counter: false
    });
  }

  // ============================================== //
  // ============== corona page ============== //

  if ($(".filter-sticky_js").length > 0) {
    $(".filter-sticky_js").hcSticky({
      stickTo: ".sticky-parent",
      top: $(".main-header-inner").height(),
    });
  }

  if ($(".isotope-album").length > 0) {
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    } else {
      window.onbeforeunload = function () {
        window.scrollTo(0, 0);
      };
    }

    // init Isotope
    var $imgs = $("img.lazyload"),
      $filterButtonGroup = $(".filters-button-group_js"),
      $grid = $(".grid-isotope_js");

    //default url
    if (document.location.href.indexOf("?") === -1) {
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?section=*";

      window.history.pushState({ path: newurl }, "", newurl);
    }

    var $gridIso = $grid.imagesLoaded(function () {
      // init Isotope when grid's images have loaded
      $gridIso.isotope({
        itemSelector: ".grid-isotope-item_js",
        originLeft: false,
        layoutMode: "masonry",
        percentPosition: true,
        masonry: {
          columnWidth: ".grid-sizer",
        },
      });
    });

    function getSection() {
      var url = window.location.href; // get url
      var section = url.substring(url.indexOf("=") + 1);

      if ($(".filter-animate_js").length > 0 && section != "*") {
        $("html, body").animate(
          { scrollTop: $(".filter-sticky_js").offset().top },
          1000
        );
      }

      return section === "*" ? section : "." + section;
    }

    // bind filter button click
    $filterButtonGroup.on("click", "button", function () {
      $("html, body").animate(
        {
          scrollTop: $(".sticky-parent").offset().top,
        },
        100
      );

      var filterAttr = $(this).attr("data-filter");
      var sectionAttr = $(this).attr("data-filter").replace(".", "");
      //create new url with section name
      var newurl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        "?section=" +
        sectionAttr;
      window.history.pushState({ path: newurl }, "", newurl);

      //filterAttr = filterAttr;
      $gridIso.isotope({ filter: filterAttr });

      // layout Isotope after each image loads
      $gridIso.imagesLoaded().progress(function () {
        $gridIso.isotope("layout");
        //console.log("imagesloaded");
      });

      onUrlchange();
    });

    // change is-checked class on buttons
    $filterButtonGroup.each(function (i, buttonGroup) {
      var $buttonGroup = $(buttonGroup);
      $buttonGroup.on("click", "button", function () {
        //   $buttonGroup.find('.is-checked').removeClass('is-checked');
        $(this).addClass("is-checked");
      });
    });

    function onUrlchange() {
      var section = getSection(),
        urlSection = section.replace(".", "");

      // layout Isotope after each image loads
      $(document).on("lazybeforeunveil", function () {
        $gridIso.isotope("layout");
      });

      // run layout on scroll up
      var waypoint = new Waypoint({
        element: $(".grid-isotope_js")[0],
        handler: function (direction) {
          if (direction == "down") {
            $gridIso.isotope("layout");
          }
        },
      });

      var filterValue = section;
      $gridIso.isotope({ filter: filterValue });

      // FOR ITEMS ADD HREF
      // reset data-id on change
      $(".grid-isotope-item_js").attr("data-id", "");

      // add href to items
      $(".item-href_js" + section).each(function (index) {
        $(this).attr("data-id", index + 1);
        var itemHref = $(".article-img a", this).attr("href");
        var hrefIndex = itemHref.indexOf("?section");
        if (hrefIndex > 0) {
          itemHref = itemHref.slice(0, hrefIndex);
        }
        var urlVal =
          "?section=" + section + "#/photo/" + $(this).attr("data-id");
        //console.log(urlVal, "urlVal");
        $(".article-img a", this).attr("href", itemHref + urlVal);
        $(".photo-title a", this).attr("href", itemHref + urlVal);
      });

      // add ischecked to the active section
      if (section) {
        $filterButtonGroup.find(".is-checked").removeClass("is-checked");
        $filterButtonGroup
          .find('[data-category="' + urlSection + '"]')
          .addClass("is-checked");
        $filterButtonGroup
          .find('[data-filter="' + section + '"]')
          .addClass("is-checked");
      }
    }

    //$(window).on( 'hashchange', onUrlchange );

    // trigger event handler to init Isotope
    onUrlchange();
  }

  // ============== end corona page ============== //
  // ============================================== //

  // ============================================== //
  // ============== photographer-profile page  ============== //
  if ($(".photographer-profile-section").length > 0) {
    //console.log('photographer profile');

    // init Isotope
    var $grid = $(".grid-isotope_js").isotope({
      itemSelector: ".grid-isotope-item_js",
      percentPosition: true,
      originLeft: false,
      layoutMode: "masonry",
      masonry: {
        columnWidth: ".grid-sizer",
      },
    });
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress(function () {
      $grid.isotope("layout");
    });

    function itemHref() {
      $(document).on("lazybeforeunveil", function () {
        $grid.isotope("layout");
      });
      // FOR ITEMS
      // reset data-id on change
      $(".grid-isotope-item_js").attr("data-id", "");
      // add href to items
      $(".grid-isotope-item_js").each(function (index) {
        $(this).attr("data-id", index + 1);
        var itemHref = $(".article-img a", this).attr("href");
        var hrefIndex = itemHref.indexOf("?section");
        if (hrefIndex > 0) {
          itemHref = itemHref.slice(0, hrefIndex);
        }
        var urlVal = "#photo/" + $(this).attr("data-id");
        $(".article-img a", this).attr("href", itemHref + urlVal);
        $(".photo-title a", this).attr("href", itemHref + urlVal);
        // $('.article-img a',this).attr('href',window.location.protocol + "//" + window.location.host + window.location.pathname + '#photo/'+$(this).attr("data-id"));
      });
    }
    itemHref();
  }

  // ============== end photographer-profile page  ============== //
  // ============================================== //

  if ($(".tall-block_js").length > 0) {
    function eqH() {
      $(".tall-block_js").each(function (i, obj) {
        var firstItemH = $(this)
            .closest(".section-content")
            .find(".col-block_js .cell:first-child")
            .height(),
          firstItemImgH = $(this)
            .closest(".section-content")
            .find(".col-block_js .cell:first-child .article-item img")
            .height(),
          totalHeight = firstItemH + firstItemImgH;

        $("img", this).css({
          height: totalHeight + "px",
          "object-fit": "cover",
          width: "100%",
        });
      });
    }

    if (Foundation.MediaQuery.is("medium up") == true) {
      setTimeout(() => {
        eqH();
        $(window).resize(function () {
          eqH();
        });
      }, "500");
    }
  }

  // MATCH HEIGHT

  if ($(".c-item-h").length > 0) {
    $.fn.matchHeight._rows($(".c-item-h .article-item"));
  }

  if ($(".eq-height_js").length > 0) {
    function eqHB() {
      $(".eq-height_js").each(function (i, obj) {
        var firstItemH = $(this)
            .closest(".section-content")
            .find(".col-block_js .cell .article-item img")
            .height(),
          totalHeight = firstItemH;

        $("img", this).css({
          height: totalHeight + "px",
          "object-fit": "cover",
          width: "100%",
        });
      });
    }

    if (Foundation.MediaQuery.is("medium up") == true) {
      setTimeout(() => {
        eqHB();
        $(window).resize(function () {
          eqHB();
        });
      }, "500");
    }
  }

  // ============================================== //
  // ============== copy to clipboard Start  ============== //
  if ($("#clipboardCopy").length > 0) {
    var $temp = $("<input>");
    var $url = $(".hidden-url").attr("data-url");
    $("#clipboardCopy").foundation("hide");
    $("#clipboardCopy").on("click", function (e) {
      e.preventDefault();
      $("body").append($temp);
      $temp.val($url).select();
      document.execCommand("copy");
      $temp.remove();

      $(this).foundation("show");

      setTimeout(function () {
        $("#clipboardCopy").foundation("hide");
      }, 1000);
    });
  }
  // ============== end copy to clipboard  ============== //
  // ============================================== //

  // ============== START : SCROLL TO TOP  ============== //

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 50) {
      $(".scrollToTop-js").fadeIn();
    } else {
      $(".scrollToTop-js").stop(true, true).fadeOut();
    }
  });

  $(".scrollToTop-js").on("click", function () {
    $("html,body").animate(
      {
        scrollTop: $("#main-header").offset().top,
      },
      500
    );
    return false;
  });

  // ============== END : SCROLL TO TOP  ============== //

  //DISAPPEARING AD on scroll
  // var leaderboard = $(".disappearing-ad_js");
  // function disappearingAd() {
  //     // if (Foundation.MediaQuery.only('small') == true){
  //     //     $(window).on('scroll', function() {
  //     //         if ($(window).scrollTop() >= $('.grid-x:first-child .sidebar-wrap').offset().top + $('.grid-x:first-child .sidebar-wrap').outerHeight() - window.innerHeight) {
  //     //             $(leaderboard).hide();
  //     //         }
  //     //     });
  //     // }
  //     var lastScrollTop = 0;
  //     $(window).on('scroll', function (event) {
  //         var st = $(this).scrollTop();
  //         if (st > lastScrollTop) {
  //             setTimeout(function () {
  //                 $('.sticky.disappearing-ad_js').hide(); //hide leaderboard after 5 seconds
  //                 $('.sticky.disappearing-ad_js').addClass('loaded');
  //             }, 5000);

  //         }
  //         lastScrollTop = st;
  //         // console.log(st);
  //         if (st == 0) {
  //             $(leaderboard).show();
  //         }
  //     });
  // }
  // disappearingAd();
  // $(window).on('resize', function () {
  //     disappearingAd()
  // });

  // ========================  GA4 START ========================  //

  if ($("#contact-message-feedback-form")) {
    $("#contact-message-feedback-form").on("submit", function (e) {
      e.preventDefault();

      setTimeout(function () {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "contact_form_submit",
          page_type: "contact",
        });
        dataLayer.push({
          event: "custom_page_view",
          page_type: "contact",
        });
      }, 100);
    });
  }

  // ========================  GA4 END ========================  //

  // ========================  TV START ========================  //
  if ($(".main-carousel-trigger").length) {
    var gridCarousel1 = $(".main-carousel-trigger");
    gridCarousel1.slick({
      asNavFor: ".background-carousel-trigger",
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      rtl: true,
      rows: 0,
      adaptiveHeight: true,
    });

    var gridCarousel2 = $(".background-carousel-trigger");
    gridCarousel2.slick({
      asNavFor: ".main-carousel-trigger",
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      rtl: true,
      fade: true,
      rows: 0,
      adaptiveHeight: false,
    });
  }

  if ($(".grid-carousel-trigger").length) {
    var gridCarousel3 = $(".grid-carousel-trigger");
    gridCarousel3.slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      arrows: true,
      dots: false,
      rtl: true,
      rows: 0,
      prevArrow: $(".slider-custom-arrow .slick-prev"),
      nextArrow: $(".slider-custom-arrow .slick-next"),
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 901,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1.2,
            centerMode: true,
          },
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  if ($(".share-btn-js").length) {
    $(".share-btn-js").on("click", function () {
      $(".share-btn").toggleClass("btn-open");
    });
  }

  if ($(".tab-carousel-trigger").length) {
    $(".tab-carousel-trigger").each(function (index) {
      var gridCarousel4 = $(this);
      gridCarousel4.slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        dots: false,
        rtl: true,
        setPosition: 0,
        rows: 0,
        nextArrow: $(".slider-custom-arrow .slick-next")[index],
        prevArrow: $(".slider-custom-arrow .slick-prev")[index],
        responsive: [
          {
            breakpoint: 1201,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 901,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 561,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });

    $(".tabs li a").on("click", function (e) {
      $(".tab-carousel-trigger").slick("refresh");
    });
  }

  if ($(".episodes-content").length) {
    //hide all tab episodes first
    $(".episodes-content").hide();
    //show the first tab content
    $("#episode-1").show();

    $("#select-box").on("change", function () {
      var dropdown = $("#select-box").val();
      //first hide all tabs again when a new option is selected
      $(".episodes-content").hide();
      //then show the tab content of whatever option value was selected
      $("#" + "episode-" + dropdown).show();
    });
  }

  // ========================  TV END ========================  //

  // ======================= CALENDAR ======================== //
  //var calendarEl = document.getElementById("ovulation-calendar");

  // const calendar = new Calendar(calendarEl, {
  //   plugins: [dayGridPlugin],
  //   initialView: 'dayGridMonth',
  //   locales: [ esLocale ],
  //   locale: 'ar', // the initial locale. if not specified, uses the first one
  //   eventBackgroundColor:'red',
  //   initialDate: '2024-06-10',
  //   events: [
  //     {
  //       groupId: 'testGroupId',
  //       start: '2024-06-10T10:00:00',
  //       end: '2024-06-10T16:00:00',
  //       display: 'background'
  //     }
  //   ]
  // });
  // calendar.render();

  if ($(".fetal-dev-slider").length) {
    var $fetalDev = $(".fetal-dev-slider");

    $fetalDev.on(
      "init reInit afterChange",
      function (event, slick, currentSlide) {
        var i = (currentSlide ? currentSlide : 0) + 1;
        var previousSlide = (currentSlide ? currentSlide : 0) + 1;
        var nextSlide = (currentSlide ? currentSlide : 0) + 3;
        $(".fetal-prev-count").text(previousSlide);
        $(".fetal-next-count").text(nextSlide);
      }
    );

    $fetalDev.slick({
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      loop: false,
      rtl: true,
      prevArrow: ".prev-btn",
      nextArrow: ".next-btn",
    });
  }

  if ($("#calcOvulation").length) {
    const formCalcOvulation = document.getElementById("calcOvulation");

    formCalcOvulation.addEventListener("click", (e) => {
      ovulationCalendar();
    });
  }
});

function ovulationCalendar() {
  if ($("#ovulation-calendar").length) {
    var calendarEl = document.getElementById("ovulation-calendar"),
      dateStart = $(".calculator-result").find("#dateStart").attr("data-date"),
      dateOnset = $(".calculator-result").find("#dateOnset").attr("data-date"),
      dateOvulation = $(".calculator-result")
        .find("#dateOvulation")
        .attr("data-date"),
      dateEnd = $(".calculator-result").find("#dateEnd").attr("data-date"),
      dateBest = $(".calculator-result").find("#dateBest").attr("data-date"),
      dateExpected = $(".calculator-result")
        .find("#dateExpected")
        .attr("data-date");

    var calendar = new Calendar(calendarEl, {
      plugins: [dayGridPlugin],
      locale: "ar",
      contentHeight: 500,
      // headerToolbar: {
      //   left: 'prev,next today',
      //   center: 'title',
      //   right: 'dayGridMonth'
      // },
      headerToolbar: {
        start: "prev", // will normally be on the left. if RTL, will be on the right
        center: "title",
        end: "next", // will normally be on the right. if RTL, will be on the left
      },
      initialDate: dateStart,
      events: [
        {
          start: dateStart,
          end: dateStart,
          display: "background",
          color: "#636363",
        },
        {
          start: dateOnset,
          end: dateOnset,
          display: "background",
          color: "#000000",
        },
        {
          start: dateOvulation,
          end: dateOvulation,
          display: "background",
          color: "#961b3d",
        },
        {
          start: dateEnd,
          end: dateEnd,
          display: "background",
          color: "#000000",
        },
        {
          start: dateBest,
          end: dateBest,
          display: "background",
          color: "#464646",
        },
        {
          start: dateExpected,
          end: dateExpected,
          display: "background",
          color: "#363636",
        },
      ],
    });

    calendar.render();
  }
}

// RIYADH SEASON CALENDAR EVETNS
if ($("#calendarEvents").length > 0) {
  var calendarEventsURL = "",
    tid = "riyadh-season",
    activeDay = $(".tabs-slider_js li.is-active").data("day"),
    activeMonth = $(".tabs-slider_js li.is-active").data("month"),
    today = new Date(),
    todayMonth = today.getMonth() + 1,
    todayDay = today.getDate();

  //console.log(todayDay, 'todayDay');
  //console.log(todayMonth, 'month today');

  var ar = moment().locale("ar");

  const month = [
    moment("2021-10-01", "YYYY-MM-DD"),
    moment("2021-12-30", "YYYY-MM-DD"),
  ];
  const range = moment().range(month);
  const days = range.by("days");

  var localMonth = moment().locale("ar");
  //console.log(localMonth.format('MMMM'), 'local');

  var daysOfMonth = [...days].map(function (date) {
    //date => date.format('DD')
    var d = date.format("DD");
    var m = date.format("MMMM");
    var mm = date.format("MM");
    var monthAr = ar.localeData().months(date);

    $(".tabs-slider_js").append(
      '<li class="tabs-title" data-day="' +
        d +
        '" data-month="' +
        mm +
        '"><a href="#panel' +
        d +
        "" +
        mm +
        'v"> ' +
        d +
        " " +
        monthAr +
        " </a></li>"
    );
    $(".event-tabs-content_js").append(
      '<div class="tabs-panel events-slick-item_js"  data-day="' +
        d +
        '" data-month="' +
        mm +
        '" id="panel' +
        d +
        "" +
        mm +
        'vv"><div class="events-item_js">' +
        '<div class="ajax-loader text-center">' +
        '<img src="https://www.sayidaty.net/themes/custom/sayidaty/assets/img/ajax-loader.gif"/>' +
        "</div>" +
        "</div> </div> "
    );
  });

  setTimeout(function () {
    var slickIndex = $(
      '.tabs-title[data-day="' +
        todayDay +
        '"][data-month="' +
        todayMonth +
        '"]'
    )
      .closest(".slick-slide")
      .attr("data-slick-index");
    $(".tabs-slider_js").slick("slickGoTo", slickIndex);

    var slickItemIndex = $(
      '.events-slick-item_js[data-day="' +
        todayDay +
        '"][data-month="' +
        todayMonth +
        '"]'
    )
      .closest(".slick-slide")
      .attr("data-slick-index");
    $(".event-tabs-content_js").slick("slickGoTo", slickItemIndex);
  }, 1000);

  //console.log(todayDay, todayMonth, 'todayDay, todayMonth');
  function loadData(thisDay, thisMonth) {
    if (
      location.hostname === "localhost" ||
      location.hostname === "127.0.0.1"
    ) {
      calendarEventsURL =
        "assets/json/riyadh-season-" + thisDay + "-" + thisMonth + ".json";
    } else {
      calendarEventsURL =
        "https://www.sayidaty.net/riyadh-season-events/" +
        thisDay +
        "/" +
        thisMonth +
        "";
    }

    $.ajax({
      url: calendarEventsURL,
      dataType: "json",
      cache: false,
      beforeSend: function () {
        $(".ajax-loader").css("visibility", "visible");
      },
      error: function () {
        $(
          ".event-tabs-content_js .slick-current.slick-active .events-item_js"
        ).html('<div class="padding-3 text-center"><p>No Event</p></div>');
      },
    }).done(function (events) {
      // console.log('events: ', events)
      var articleItem = "";
      if (events.length > 0) {
        articleItem = events.map(function (item) {
          return (
            '<div class="grid-x events-card align-middle">' +
            '<div class="cell small-12 medium-shrink large-shrink events-img">' +
            '<img src="' +
            item.field_event_image +
            '" class="events img">' +
            "</div>" +
            '<div class="cell small-12 medium-auto large-auto events-info">' +
            '<div class="events-date">' +
            item.field_event_date +
            "</div>" +
            '<div class="events-title">' +
            "<h2>" +
            item.title +
            "</h2>" +
            "</div>" +
            '<div class="events-cat">' +
            item.field_subtitle +
            "</div>" +
            "</div>" +
            '<div class="cell small-12 medium-shrink large-shrink events-book">' +
            (item.field_buy_online == ""
              ? ""
              : '<div class="book-btn"><a href="' +
                item.field_buy_online +
                '" class="button hollow secondary" style="margin:0 0 1rem 0"> شاهد أونلاين </a></div>') +
            (item.field_watch_online == ""
              ? ""
              : '<div class="book-btn"><a href="' +
                item.field_watch_online +
                '" class="button hollow secondary expanded"> احجز تذكرتك </a></div>') +
            "</div>" +
            "</div>"
          );
        });
        $(
          ".event-tabs-content_js .slick-current.slick-active .events-item_js"
        ).html(articleItem);
      } else {
        $(
          ".event-tabs-content_js .slick-current.slick-active .events-item_js"
        ).html('<div class="padding-3 text-center"><p>No Event</p></div>');
      }
    });
  }

  // SLICK

  var $tabsSlider = $(".tabs-slider_js");
  $tabsSlider.slick({
    slidesToShow: 12,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    rtl: true,
    focusOnSelect: true,
    prevArrow: $(".v-prev"),
    nextArrow: $(".v-next"),
    asNavFor: ".event-tabs-content_js",
    responsive: [
      {
        breakpoint: 641,
        settings: {
          swipe: false,
          slidesToShow: 4,
        },
      },

      {
        breakpoint: 769,
        settings: {
          slidesToShow: 6,
        },
      },
    ],
  });

  var $eventContentSlider = $(".event-tabs-content_js");
  $eventContentSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    centerMode: false,
    arrows: false,
    focusOnSelect: false,
    rtl: true,
    asNavFor: ".tabs-slider_js",
  });

  $eventContentSlider.on(
    "afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var elSlide = $(slick.$slides[currentSlide]);
      var currentSlideDay = $(".events-slick-item_js", elSlide).data("day");
      var currentSlideMonth = $(".events-slick-item_js", elSlide).data("month");

      //console.log(currentSlideDay, currentSlideMonth, "currentSlideDay, currentSlideMonth");
      loadData(currentSlideDay, currentSlideMonth);
    }
  );
}

if ($("#tv_sayidaty").length > 0) {
  var tvurl = "";
  var tvurl = $("#tv_sayidaty").data("tv-path");

  $.ajax({
    url: tvurl,
    dataType: "json",
    cache: false,
  }).done(function (result) {
    // console.log('result: ', result)

    var articleItem = "";
    // console.log('articlesList: ', articlesList)
    if (result.length > 0) {
      for (var i = 0; i <= result.length; i++) {
        //    console.log('articlesList[i]', articlesList[i].url);
        if (i == 0) {
          articleItem +=
            '<div class="grid-x grid-margin-x">' +
            '<div class="cell large-auto">' +
            '   <div class="article-item">' +
            '       <div class="article-item-img">' +
            '           <a title="' +
            result[i].title +
            '" href="' +
            result[i].Path +
            '">' +
            '               <img title="' +
            result[i].title +
            '" alt="' +
            result[i].title +
            '" src="' +
            result[i].largeimage +
            '">' +
            '               <span class="play-icon"><i class="icomoon-icon icon-play"></i></span>' +
            "           </a>" +
            "       </div>" +
            '       <div class="article-item-info">' +
            '           <div class="article-item-category">' +
            '               <a title="' +
            result[i].section +
            '" href="' +
            result[i].tid +
            ' ">' +
            result[i].section +
            "</a>" +
            "           </div>" +
            '           <div class="article-item-title">' +
            '               <h4><a title="' +
            result[i].title +
            '" href="' +
            result[i].Path +
            '">' +
            result[i].title +
            "</a></h4>" +
            "           </div>" +
            "       </div>" +
            "   </div>" +
            "</div>" +
            '<div class="cell large-shrink show-for-large">' +
            '   <div class="sidebar-wrap sticky-area">' +
            '       <div class="block-wrapper">' +
            '           <div class="block-content">' +
            '               <div class="text-center">' +
            '               <a title="' +
            result[i].title +
            '" href="' +
            result[i].Path +
            '"></a>' +
            "               </div>" +
            "           </div>" +
            "       </div>" +
            "   </div>" +
            "   </div>" +
            "</div>";
        }
        if (i == 1) {
          articleItem +=
            '<div class="grid-items grid-x grid-margin-x small-up-1 medium-up-2 large-up-4">';
        }
        if (i > 0 && i < 5) {
          articleItem +=
            '<div class="cell">' +
            '   <div class="article-item">' +
            '       <div class="article-item-img">' +
            '           <a title="' +
            result[i].title +
            '" href="' +
            result[i].Path +
            '">' +
            '               <img title="' +
            result[i].title +
            '" title="' +
            result[i].title +
            '" src="' +
            result[i].smallimage +
            '">' +
            '               <span class="play-icon"><i class="icomoon-icon icon-play"></i></span>' +
            "           </a>" +
            "       </div>" +
            '       <div class="article-item-info">' +
            '           <div class="article-item-category">' +
            '               <a title="' +
            result[i].section +
            '" href="' +
            result[i].tid +
            ' ">' +
            result[i].section +
            "</a>" +
            "           </div>" +
            '           <div class="article-item-title">' +
            '               <h4><a title="' +
            result[i].title +
            '" href="' +
            result[i].Path +
            '">' +
            result[i].title +
            "</a></h4>" +
            "           </div>" +
            "       </div>" +
            "   </div>" +
            "</div>";
        }
        if (i == 4) {
          articleItem += "</div>";
        }
      }
      $("#tv_sayidaty").append(articleItem);
    }
  });
}
if ($("#most-read-carousel_js").length > 0) {
  var urlpath = "";
  var tid = "";
  if ($(".entry-article__content.first-article-node").length > 0) {
    tid = $(".entry-article__content.first-article-node").data("section-id");
    urlpath = "https://pv.srpcdigital.com/list/daily/5/article/" + tid;
  } else if ($("#most-read-carousel_js").length > 0) {
    tid = $("#most-read-carousel_js").data("top10-tid");

    urlpath = "https://pv.srpcdigital.com/list/daily/5/article/" + tid;
  } else {
    urlpath = "https://pv.srpcdigital.com/list/daily/5/article";
  }

  var domain = "www.sayidaty.net";
  var apik =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb21haW4iOiJzYXlpZGF0eW5ldGRrIn0.OgHDaC4QxWie9DEuzNBHNKyC-GXr1O-_lBHrmmIBmqA";

  $.ajax({
    url: urlpath,
    method: "GET",
    headers: {
      Origin: domain,
      APIK: apik,
    },
    success: function (response) {
      var articleItem = ""; // console.log(articlesList.length, 'count');
      // Loop through the keys of the response object
      for (const key in response) {
        if (response.hasOwnProperty(key)) {
          const array = response[key]; // Get the array for the current key

          articleItem =
            '<div><div><div class="carousel-item">' +
            '<div class="article-item">' +
            '<div class="article-item-img ">' +
            (array["imageUrl"] === ""
              ? '                        <a title="' +
                array["title"] +
                '" href="' +
                array["articleUrl"] +
                '"> <img class="" src="https://www.sayidaty.com/sites/default/files/default_images/default-thumbnail_1_0.jpeg" alt=""></a>'
              : '<a href="' +
                array["articleUrl"] +
                '"> <img class="" src="' +
                array["imageUrl"] +
                '" alt="' +
                array["title"] +
                '" title="' +
                array["title"] +
                '"></a>') +
            "</div>" +
            '<div class="article-item-info ">' +
            '<div class="article-item-title">' +
            '       <h5><a title="' +
            array["title"] +
            '" href="' +
            array["articleUrl"] +
            '">' +
            array["title"] +
            "</a></h5>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div></div></div>";
          $(".most_read .most-read-carousel_js").slick("slickAdd", articleItem);
        }
      }
    },
    error: function (xhr, status, error) {
      console.error("Error:", status, error);
    },
  });
}

if ($(".kitchen-block").length > 0) {
  try {
    jQuery.getJSON(
      "https://kitchen.sayidaty.net/json-v2/sayidaty_api/sayidaty_recipes_img_dim/3",
      function (data) {
        var html = "";
        jQuery.each(data, function (i, item) {
          html +=
            '<div class="cell">' +
            '                                  <div class="article-item">' +
            '                                     <div class="article-item-img">' +
            '                                        <a title="' +
            item.title +
            '" href="' +
            item.link +
            '">' +
            '                                           <img height="445" width="445" title="' +
            item.title +
            '" alt="' +
            item.title +
            '" src="' +
            item.image +
            '"> ' +
            "                                      </a>" +
            "                                 </div>" +
            '                                <div class="article-item-info">' +
            '                                   <div class="article-item-category">' +
            '                                      <a title="' +
            item.title +
            '" href="' +
            item.category_link +
            '">' +
            item.category +
            "</a>" +
            "                                 </div>" +
            '                                <div class="article-item-title">' +
            '                                   <h4><a title="' +
            item.title +
            '" href="' +
            item.link +
            '">' +
            item.title +
            "</a></h4>" +
            "                              </div>" +
            "                         </div>" +
            "                    </div>" +
            "               </div>";
        });
        jQuery(".kitchen-block").replaceWith(html);
      }
    );
  } catch (err) {
    console.log("products json has failed");
  }
}
if ($("#kitchen-block_2").length > 0) {
  try {
    jQuery.getJSON(
      "https://kitchen.sayidaty.net/json/sayidaty_api/sayidaty_tipsNew/1",
      function (data) {
        var html = "";
        jQuery.each(data, function (i, item) {
          html +=
            '<div class="cell">' +
            '                                  <div class="article-item">' +
            '                                     <div class="article-item-img">' +
            '                                        <a title="' +
            item.title +
            '" href="' +
            item.link +
            '">' +
            '                                           <img height="445" width="445" title="' +
            item.title +
            '" alt="' +
            item.title +
            '" src="' +
            item.image +
            '">' +
            '<span class="media-label abs-el"><i class="icomoon-icon icon-chef"></i></span> ' +
            "                                      </a>" +
            "                                 </div>" +
            '                                <div class="article-item-info">' +
            '                                   <div class="article-item-category">' +
            '                                      <a title="' +
            item.title +
            '" href="https://kitchen.sayidaty.net/%D9%86%D8%B5%D8%A7%D8%A6%D8%AD-%D8%A7%D9%84%D8%B4%D9%8A%D9%81">   نصائح الشيف    </a>   ' +
            "                                 </div>" +
            '                                <div class="article-item-title">' +
            '                                   <h4><a title="' +
            item.title +
            '" href="' +
            item.link +
            '">' +
            item.title +
            "</a></h4>" +
            "                              </div>" +
            "                         </div>" +
            "                    </div>" +
            "               </div>";
        });
        jQuery("#kitchen-block_2").replaceWith(html);
      }
    );
  } catch (err) {
    console.log("products json has failed");
  }
}
if ($(".kitchen-block_3").length > 0) {
  try {
    jQuery.getJSON(
      "https://kitchen.sayidaty.net/json/sayidaty_api/sayidaty_recipes/4/ramadan",
      function (data) {
        var html = "";
        jQuery.each(data, function (i, item) {
          html +=
            '<div class="cell">' +
            '                                  <div class="article-item">' +
            '                                     <div class="article-item-img">' +
            '                                        <a title="' +
            item.title +
            '" href="' +
            item.link +
            '">' +
            '                                           <img height="445" width="445" title="' +
            item.title +
            '" alt="' +
            item.title +
            '"src="' +
            item.image +
            '"> ' +
            "                                      </a>" +
            "                                 </div>" +
            '                                <div class="article-item-info">' +
            '                                   <div class="article-item-category">' +
            '                                      <a title="' +
            item.title +
            '" href="' +
            item.category_link +
            '">' +
            item.category +
            "</a>" +
            "                                 </div>" +
            '                                <div class="article-item-title">' +
            '                                   <h4><a title="' +
            item.title +
            '" href="' +
            item.link +
            '">' +
            item.title +
            "</a></h4>" +
            "                              </div>" +
            "                         </div>" +
            "                    </div>" +
            "               </div>";
        });
        jQuery(".kitchen-block_3").replaceWith(html);
      }
    );
  } catch (err) {
    console.log("products json has failed");
  }
}

//QUIZ

// QUIZ START JS

$(document).ready(function () {
  $(".quiz-begin-btn a").on("click", function (ev) {
    ev.preventDefault();
    $(".quiz-ready-block").slideUp();
    $(".cycled-quiz-wrapper").slideDown("fast", function () {
      $cycledFieldset.get(0).slick.setPosition();
      $("html, body").animate(
        {
          scrollTop: $(".uptohere").offset().top - 140,
        },
        2000
      );
    });
  });
  $(".content-multigroup-wrapper").each(function (index, element) {
    // $(this).find('.field-item').each(function (i) {
    //     var input = "<input type='radio' name='quiz_answer" + (index + 1) + "' value=" + i + ">";
    //     $(this).prepend(input);
    // });
    $(this)
      .find(".field-item")
      .each(function (i) {
        var input =
          "<input type='radio' name='quiz_answer" +
          (index + 1) +
          "' id='quiz_answer" +
          (index + 1) +
          "_" +
          i +
          "' value=" +
          i +
          ">";
        var label =
          "<label for='quiz_answer" + (index + 1) + "_" + i + "'></label>";
        //jQuery(this).find('span').prepend(input);
        $(this).find("span").wrap(label).before(input);
      });
  });
  $('input:radio[name*=quiz_answer]:radio[value="0"]').remove();
  $("input:radio[name*=quiz_answer]").on("click", function () {
    countAnswer();
    if ($(this).is(":checked")) {
      $(this)
        .parents(".content-multigroup-wrapper")
        .find(".field-item span")
        .removeClass("checked");
      $(this).next().addClass("checked");
      $cycledFieldset.slick("slickNext");
    }
  });
  $(".quiz_myresult").on("click", function (ev) {
    ev.preventDefault();
    $(
      ".field-field-quiz-result-a, .field-field-quiz-result-b, .field-field-quiz-result-c, .field-field-quiz-result-d"
    ).removeClass("message status");
    $(".group-quiz-result").slideDown();
    var x = ["0", sumAnswer(1), sumAnswer(2), sumAnswer(3), sumAnswer(4)];
    var j = 0;
    for (var i = 0; i < x.length; i++) {
      if (x[i] > x[j]) j = i;
    }
    var max = x[j];
    var res = x.indexOf(max);
    switch (res) {
      case 1:
        scrollToAnswer("a");
        break;
      case 2:
        scrollToAnswer("b");
        break;
      case 3:
        scrollToAnswer("c");
        break;
      case 4:
        scrollToAnswer("d");
        break;
    }
  });

  var $cycledFieldset = $("#cycled-fieldset");

  $cycledFieldset.on("init", function (event, slick) {
    onAfter(event, slick, 0);
  });
  $cycledFieldset.slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    rtl: true,
    fade: true,
    accessibility: false,
  });
  $cycledFieldset.on("afterChange", function (event, slick, currentSlide) {
    onAfter(event, slick, currentSlide);
  });

  function onAfter(event, slick, currentSlide) {
    $(".slides-count .current-slide").text(slick.currentSlide + 1);
    $(".slides-count .slides-total").text(slick.slideCount - 1);
    var Left = $(".prev-quiz-box");
    var Right = $(".next-quiz-box");
    var index = slick.currentSlide;
    index == 0
      ? Left.css("visibility", "hidden")
      : Left.css("visibility", "visible");
    index == slick.slideCount - 1
      ? Right.css("visibility", "hidden")
      : Right.css("visibility", "visible");
    index == slick.slideCount - 1
      ? $(".slides-count").hide()
      : $(".slides-count").show();
    $(".error-msg").hide();
  }

  $(".quiz_reset").on("click", function (ev) {
    ev.preventDefault();
    $(
      ".field-field-quiz-result-a, .field-field-quiz-result-b, .field-field-quiz-result-c, .field-field-quiz-result-d, .field-field-quiz-result-e, .field-field-quiz-result-f"
    ).removeClass("message status");
    $(
      ".group-quiz-result, .field-field-quiz-result-a, .field-field-quiz-result-b, .field-field-quiz-result-c, .field-field-quiz-result-d, .field-field-quiz-result-e, .field-field-quiz-result-f"
    ).hide();
    $("input:radio[name*=quiz_answer]").prop("checked", false);
    $(".content-multigroup-wrapper")
      .find(".field-item span")
      .removeClass("checked");
    countAnswer();
    $cycledFieldset.slick("slickGoTo", 0);
    $("html, body").animate(
      {
        scrollTop: $("#cycled-fieldset").offset().top - 140,
      },
      2000
    );
    $(".quiz-controls").slideDown();
  });
  $("input:radio[name*=quiz_answer]").on("click", function () {
    if ($(this).is(":checked")) {
      $cycledFieldset.slick("slickNext");
    }
  });
  $(".prev-quiz-box").on("click", function () {
    $cycledFieldset.slick("slickPrev");
    return false;
  });
  $(".next-quiz-box").on("click", function () {
    var $currentQuizSlide = $(
      $cycledFieldset
        .slick("getSlick")
        .$slides.get($cycledFieldset.slick("slickCurrentSlide"))
    );
    var checked = $currentQuizSlide.find(
      "input:radio[name*=quiz_answer]:checked"
    );
    if (checked.length == 0) {
      $(".error-msg").show();
      return false;
    } else {
      $(".error-msg").hide();
      $cycledFieldset.slick("slickNext");
      return false;
    }
  });
});

function sumAnswer(opt) {
  var sum = 0;
  $("input:radio[name*=quiz_answer]:checked").each(function (i) {
    if ($(this).val() == opt) {
      sum++;
    }
  });
  return sum;
}

function countAnswer() {
  var optA = sumAnswer(1);
  var optB = sumAnswer(2);
  var optC = sumAnswer(3);
  var optD = sumAnswer(4);
  var optE = sumAnswer(5);
  var optF = sumAnswer(6);
  $(".result_a").text(optA);
  $(".result_b").text(optB);
  $(".result_c").text(optC);
  $(".result_d").text(optD);
  $(".result_e").text(optE);
  $(".result_f").text(optF);
}

function scrollToAnswer(to) {
  $(
    ".field-field-quiz-result-a, .field-field-quiz-result-b, .field-field-quiz-result-c, .field-field-quiz-result-d, .field-field-quiz-result-e, .field-field-quiz-result-f"
  ).hide();
  $(".quiz-controls").hide();
  $(".field-field-quiz-result-" + to)
    .slideDown()
    .addClass("message status");
  $("html, body").animate(
    {
      scrollTop: $(".group-quiz-result").offset().top - 140,
    },
    2000
  );
}

(function ($) {
  jQuery(document).on("views_infinite_scroll.new_content", function (evt) {
    Drupal.behaviors.infiniteScrollAddClass = {
      attach: function (context, settings) {
        var trackURL = jQuery(location).attr("pathname");
        if (trackURL != "undefined") {
          // try {
          //     trackClickView(trackURL);
          // } catch (e) {
          //     console.log("failed to send a ping to GA");
          // }

          try {
            console.log(trackURL);
            //refreshEM(trackURL);
            //console.log("samirrr");
          } catch (e) {
            console.log("failed to ping EM");
          }
        }

        // these are the elements loaded in first
      },
    };
  });
})(jQuery);
// QUIZ END JS
